module.exports = "<div class=\"sv-skeleton-element\" data-bind=\"attr: { id: element.id }, style: { height: element.skeletonHeight }\">\n</div>";